"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const contexts_1 = require("@App/contexts");
const useRightsholderReset = () => {
    const { rightsholderStore, rightsholderUserStore, catalogSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    return () => {
        catalogSearchStore.resetStore();
        rightsholderUserStore.destroyRightsHolderUserToAbility();
        rightsholderStore.destroyRightsholder();
    };
};
exports.default = useRightsholderReset;
